import { SECONDARY_REVIEWS_STATUS, SECONDARY_REVIEWS_LIST, SEARCH_SECONDARY_REVIEWS_LIST, ADD_SECONDARY_REVIEWS_SORT_KEY, ADD_SECONDARY_REVIEWS_LIST_FILTER, SECONDARY_REVIEW_DETAILS } from '../../actions-index'
import { constructFilters, constructSort, searchList, searchListByQuery } from '../../redux-helpers';
import { orderBy } from 'lodash'
import { updatedDetails } from '../util';
var hash = require('object-hash');

export function secondaryReviewList(state = {}, action) {
    const searchableProperties = ['name', 'nomineeId']
    const { _list } = state
    switch (action.type) {
        case SECONDARY_REVIEWS_LIST:
            return {
                ...state,
                list: action.payload,
                _list: action.payload,
                status: 'success'
            }
        case SECONDARY_REVIEWS_STATUS:
            return {
                ...state,
                status: action.payload
            }
        case SEARCH_SECONDARY_REVIEWS_LIST:
            const searchedList = searchList({ query: action.payload, list: _list, searchableProperties, filters: state.filters, sortKey: state.sortKey, filteringAction: addSecondaryListFilters })

            return {
                ...state,
                query: action.payload,
                list: searchedList
            }
        case ADD_SECONDARY_REVIEWS_LIST_FILTER:
            const allFilters = constructFilters(state.filters || [], action.payload)
            const filteredList = addSecondaryListFilters({ list: _list, filters: allFilters, query: state.query, searchableProperties, sortKey: state.sortKey })

            return {
                ...state,
                filters: allFilters,
                list: filteredList
            }
        case ADD_SECONDARY_REVIEWS_SORT_KEY:
            const newSortKey = {
                ...action.payload,
                ...constructSort(state.sortKey, action.payload)
            }

            return {
                ...state,
                sortKey: newSortKey,
                list: sortSecondaryReviewList(state.list || [], newSortKey)
            }
        case SECONDARY_REVIEW_DETAILS:
            return {
                ...state,
                details: updatedDetails(state.details, action.payload, 'nomineeId')
            }
        default:
            return state
    }
}

function addSecondaryListFilters(values) {
    const { list, filters, query, sortKey, searchableProperties } = values
    const getSecondaryNomineesMatchingConditions = (list = [], filters = []) => {
        const filteredList = list.filter(item => {
            const matchingNomProperties = filters.filter((filter, index) => {
                if (filter.type === 'rubric' && item.hasOwnProperty(filter.key)) {
                    const score = item[`${filter.key}`]
                    return score >= filter.min && score <= filter.max
                }
                return false
            })

            return matchingNomProperties.length === filters.length
        })

        return filteredList
    }

    let secondaryList = Array.isArray(list) && Array.isArray(filters)
        ? getSecondaryNomineesMatchingConditions(list, filters) : []

    if (query) {
        secondaryList = searchListByQuery({ query, list: secondaryList, searchableProperties })
    }
    if (sortKey) {
        secondaryList = sortSecondaryReviewList(secondaryList, sortKey)
    }

    return secondaryList
}

function sortSecondaryReviewList(list, sortKey) {
    const determineNumber = (val) => typeof val === 'string' || (typeof val === 'number' && val > 0) ? val : '-'

    let sortedList;

    if (sortKey.key === "random" && list) {
        const hashedList = list.map(nominee => {

            let jointReviewerName = "";
            if(nominee.reviewers && nominee.reviewers.length > 0) {
                nominee.reviewers.forEach(reviewer => {
                    jointReviewerName += reviewer.name;
                });
            } 
            nominee.hash = hash({
                name: nominee.name,
                awardKey: nominee.awardKey,
                shortPlan: nominee.shortPlan,
                reviewerName: nominee.reviewer ? nominee.reviewer.name : nominee.reviewers ? jointReviewerName : undefined
            });

            return nominee;
        })
        sortedList = orderBy(hashedList, "hash", sortKey.direction);
    } else {
        sortedList = orderBy(list, o => {
            if (sortKey.type === 'reviewers') {
                const { reviewers } = o
                const matchingReviewer = Array.isArray(reviewers) && reviewers.find(o => o.type === sortKey.key)
                return determineNumber(matchingReviewer.finalWeightedScore)
            }
            return o[sortKey.key]
        }, sortKey.direction)
    }
    return sortedList
}